import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To keep your account and packages secure, we strongly recommend revoking (deleting) tokens you no longer need or that have been compromised. You can revoke any token you have created.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`To see a list of your tokens, on the command line, run:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm token list
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the tokens table, find and copy the ID of the token you want to delete.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the command line, run the following command, replacing `}<inlineCode parentName="p">{`123456`}</inlineCode>{` with the ID of the token you want to delete:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm token delete 123456
`}</code></pre>
        <p parentName="li">{`npm will report `}<inlineCode parentName="p">{`Removed 1 token`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To confirm that the token has been removed, run:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm token list
`}</code></pre>
      </li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` You must use the token ID to delete a token, not the truncated version of the token. In some cases, there may be a delay of up to an hour before a token is successfully revoked.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      